import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared.module';
import {NotificationComponent} from './notification.component';
import {CardModule} from 'primeng/card';
import {FiltersModule} from './filters.module';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ToastModule} from 'primeng/toast';

@NgModule({
    declarations: [
        NotificationComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        CardModule,
        FiltersModule,
        InputSwitchModule,
        ToastModule
    ],
    exports: [
        NotificationComponent
    ]
})
export class NotificationModule {}
